import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Typography,
  CardContent,
  Card,
  List,
  ListItem,
  LinearProgress,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ErrorModal } from "@soqs/common";
import ConfirmDangerModalComponent from "./CustomComponents/ConfirmDangerModalComponent.jsx";

import {
  cancelVerification,
  clearErrors,
  errors,
  isLoading,
  otpMethods,
  selectOTPMethodAsync,
} from "../features/AppSlice.js";

const OTPTypes = ["SMS", "Email"];

const SelectOTPMethodComponent = (props) => {
  const dispatch = useDispatch();
  const otpOptions = useSelector(otpMethods);
  const loading = useSelector(isLoading);
  const errorsState = useSelector(errors);

  const [confirmBackModalOpen, setconfirmBackModalOpen] = useState(false);

  const handleSelect = async (index) => {
    //Prevent resubmission if loading
    if (!loading) {
      await dispatch(selectOTPMethodAsync(index));
    }
  };
  return (
    <>
      <Grid item xs={12}>
        <br />
        <Card>
          <CardContent>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12}>
                <Typography variant="h5">
                  Select an OTP Verification Method
                </Typography>
              </Grid>
              <Grid item xs={12} md={9}>
                <List
                  component="nav"
                  aria-label="Available OTP Methods"
                  justifyContent="center"
                >
                  {loading ? (
                    <LinearProgress />
                  ) : (
                    otpOptions?.map((option, index) => (
                      <ListItem key={index} alignItems="center">
                        <Button
                          fullWidth
                          variant="outlined"
                          onClick={() => handleSelect(index)}
                        >
                          Click here to send an OTP {OTPTypes[option.type]} to{" "}
                          {option.destinationMasked}
                        </Button>
                      </ListItem>
                    ))
                  )}
                </List>
              </Grid>
              <Grid item xs={12}>
                <Grid container justifyContent="space-between">
                  <Grid item>
                    <Button
                      type="button"
                      variant="outlined"
                      onClick={() => {
                        setconfirmBackModalOpen(true);
                      }}
                    >
                      Back
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <ErrorModal
        title={errorsState?.errortitle ?? "Error"}
        open={errorsState !== null}
        onClose={() => dispatch(clearErrors())}
        subheader={
          Array.isArray(errorsState?.error) ? (
            <ul>
              {errorsState?.error.map((e) => (
                <li>{e}</li>
              ))}
            </ul>
          ) : (
            <p>{errorsState?.error}</p>
          )
        }
      />
      <ConfirmDangerModalComponent
        title="Quit verification"
        subheader="Are you sure you want to cancel the verification process and restart?"
        confirmText="Cancel verification"
        cancelText="Continue verification"
        open={confirmBackModalOpen}
        onClose={() => setconfirmBackModalOpen(false)}
        cbConfirm={() => dispatch(cancelVerification())}
      />
    </>
  );
};

export default SelectOTPMethodComponent;
